import React, { useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Builders from "../components/Builders";
import About, { Process, Area, Faq } from "../components/About";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import BUSINESS from "../config/business";

export default function Home() {
  const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(BUSINESS.email || "");
  const isLive = Boolean(BUSINESS.live && validEmail);

  useEffect(() => {
    document.title = "JKM Coastal Carpentry & Construction LLC | Wells, ME — Portland to Portsmouth";
    const setMeta = (selector, value) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute("content", value);
    };
    setMeta(
      'meta[name="description"]',
      "Fully insured owner-operated carpentry and construction LLC in Wells, Maine. Doors, windows, decks, fences, sheds, finish woodworking, painting, core drilling and concrete slabs. Serving homeowners and builders from Portland, ME to Portsmouth, NH."
    );
  }, []);

  return (
    <>
      <a className="skip" href="#main">Skip to content</a>
      {!isLive && (
        <div className="draft-banner">
          <strong>PRIVATE WEBSITE DRAFT</strong>
          Working name and service area for review. Contact details are not connected. No requests are sent.
        </div>
      )}
      <Header />
      <main id="main">
        <Hero />
        <section className="intro" aria-label="Homeowners and builders welcome">
          <div className="wrap intro-inner">
            <span className="eyebrow">Homeowners &amp; builders welcome</span>
            <p>Owner-operated carpentry and construction for homeowners &mdash; and a dependable sub for regional builders and general contractors.</p>
          </div>
        </section>
        <Services />
        <Builders />
        <About />
        <Process />
        <Area />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <div className="mobile-cta">
        <a className="btn" href="#contact">Tell us about your project <span aria-hidden="true">&rarr;</span></a>
      </div>
    </>
  );
}
